// extracted by mini-css-extract-plugin
export default {"root":"InitialLoader_root__OH2mM","spinner":"InitialLoader_spinner__EBd+U"};